import React, { useEffect, useLayoutEffect, useState } from "react";
import useSize from "../../../Hooks/useSize.js";
import useKeyPress from "../../../Hooks/useKeyPress";
import "../../Styles/globalStyle.css";
import "../BoldIcon/BoldIcon.js";
import BoldIcon from "../BoldIcon/BoldIcon.js";
import ItalicIcon from "../ItalicIcon/ItalicIcon.js";
import UnderLineIcon from "../UnderLineIcon/UnderLineIcon.js";
import CrossedIcon from "../CrossedIcon/CrossedIcon.js";
import UlIcon from "../UlIcon/UlIcon.js";
import OlIcon from "../OlIcon/OlIcon.js";
import LeftIcon from "../LeftIcon/LeftIcon.js";
import RightIcon from "../RightIcon/RightIcon.js";
import CenterIcon from "../CenterIcon/CenterIcon.js";
import JustifyIcon from "../JustifyIcon/JustifyIcon.js";
import UndoIcon from "../UndoIcon/UndoIcon.js";
import RedoIcon from "../RedoIcon/RedoIcon.js";
import Marker from "../Marker/Marker.js";
import Link from "../Link/Link.js";
import DropDownListNew from "../../DropDownList/DropDownListNew";
import Autocomplete from "../../Autocomplete/Autocomplete";
import ReactDOM from 'react-dom';
import SimpleValidationModal from "../../SimpleValidationModal/SimpleValidationModal";
import CloseCommand from "../../Commands/CloseCommand/CloseCommand";
import AddCommand from "../../Commands/AddCommand/AddCommand";
import ValidationCommand from "../../Commands/ValidationCommand/ValidationCommand";

export default function EditorStyles(props) {

  const [link, setLink] = useState({isOpen:false, position:{}, value:props.linkStatus.value});
  const getSelectedItem = (type, itemData = {}) => {
    return {type:type, wording:itemData.wording, item:itemData.item, modal:itemData.modal}
  }
  
  const getFontTypeId = (type, fontId, itemId) => {
    // type two position fontId one position and itemdId retain
    return parseInt(`${type}${fontId}${itemId}`) 
  }

  const getSeparator = () => {
    return <div style={{  height: "13px", marginLeft:"5px",  borderRight:"1px solid rgb(223, 221, 221)" }} /> 
  }
  const getLinkId = (type) => {
    // type two position and itemdId retain
    return parseInt(`${type}${props.nextUrlId}`) 
  }
 
  const getIcon = (pos) => {

    switch (pos) {
      case 0:
        return <div key ={pos} style={{
          width: "20px", height: "20px"
          , boxSizing: "border-box", marginTop: "7px", display: "block"
        }}
          onClick={(e) => props.onClickItem(getSelectedItem(0))}>
          <BoldIcon selected={props.selecteds.includes(0)} />
        </div>;
      case 1:
        return <div  key ={pos} style={{ width: "20px", height: "20px", boxSizing: "border-box", marginTop: "7px" }}
          onClick={(e) => props.onClickItem(getSelectedItem(1))}>
          <ItalicIcon selected={props.selecteds.includes(1)}/>
        </div>;
      case 2:
        return <div  key ={pos} style={{ width: "20px", height: "20px", boxSizing: "border-box", marginTop: "7px" }}
          onClick={() => props.onClickItem(getSelectedItem(2))}>
          <UnderLineIcon selected={props.selecteds.includes(2)}/>
        </div>;
      case 3:
        return <div  key ={pos} style={{ width: "20px", height: "20px", boxSizing: "border-box", marginTop: "7px" }}
          onClick={() => props.onClickItem(getSelectedItem(3))}>
          <CrossedIcon selected={props.selecteds.includes(3)} />
        </div>;
      case 4:
        return <div  key ={pos} style={{ width: "25px", height: "20px", boxSizing: "border-box", marginTop: "7px", display: "flex"}}
          onClick={() => props.onClickItem(getSelectedItem(4))}>
          <Marker selected={props.selecteds.includes(4)}/>
          {getSeparator()}
        </div>;
      case 5:
        return <div  key ={pos} style={{ width: "20px", height: "20px", boxSizing: "border-box", marginTop: "7px" }}
          onClick={() => props.onClickItem(getSelectedItem(5))}>
          <UlIcon selected={props.selecteds.includes(5)}/>
        </div>;
      case 6:
        return <div  key ={pos} style={{ width: "25px", height: "20px", boxSizing: "border-box", marginTop: "7px", display: "flex"}}
          onClick={() => props.onClickItem(getSelectedItem(6))}>
          <OlIcon selected={props.selecteds.includes(6)}/>
          {getSeparator()}
        </div>;
      case 7:
        return <div  key ={pos} style={{ width: "20px", height: "20px", boxSizing: "border-box", marginTop: "7px" }}
          onClick={() => props.onClickItem(getSelectedItem(7))}>
          <LeftIcon selected={props.selecteds.includes(7)}/>
        </div>;
      case 8:
        return <div  key ={pos} style={{ width: "20px", height: "20px", boxSizing: "border-box", marginTop: "7px" }}
          onClick={() => props.onClickItem(getSelectedItem(8))}>
          <RightIcon selected={props.selecteds.includes(8)}/>
        </div>;
      case 9:
        return <div  key ={pos} style={{ width: "20px", height: "20px", boxSizing: "border-box", marginTop: "7px" }}
          onClick={() => props.onClickItem(getSelectedItem(9))}>
          <JustifyIcon selected={props.selecteds.includes(9)}/>
        </div>;
      case 10:
        return <div  key ={pos} style={{ width: "20px", height: "20px", boxSizing: "border-box", marginTop: "7px", display: "flex" }}
          onClick={() => props.onClickItem(getSelectedItem(10))}>
          <CenterIcon selected={props.selecteds.includes(10)}/>
          {getSeparator()}
        </div>;
      case 11:
        return <div  key ={pos} style={{ width: "20px", height: "20px", boxSizing: "border-box", marginTop: "7px" }}
          onClick={() => props.onClickItem(getSelectedItem(11))}>
          <UndoIcon selected={props.isPreviousEnabled}/>
        </div>;
      case 12:
        return <div  key ={pos} style={{ width: "20px", height: "20px", boxSizing: "border-box", marginTop: "7px" }}
          onClick={() => props.onClickItem(getSelectedItem(12))}>
          <RedoIcon selected={props.isNextEnabled}/>
        </div>;
      case 13:
        return <div  key ={pos} id ={"Link" + props.id }  style={{ width: "25px", height: "20px", boxSizing: "border-box", marginTop: "7px", display: "flex" }}
          onClick={(e) => onClickLinkItem(e)}>
          <Link selected={props.linkStatus.isSelected}/>
          {getSeparator()}
          {link.isOpen && getLinkComponent()}
        </div>;
      case 14:
         /*<div style={{ marginLeft: "2px", height: "25px" }}>
          <Autocomplete 
            placeholder={props.styleFont.font.fontFamily.value }
            isWrapped= {true} 
            style={{fontSize:14, width:"70px", height:"20px"}}
            containerStyle={{fontSize:14, width:"70px"}}
            emphasised= {false}
            data = {props.styleFont.fonts.fontFamily.values}
            onSelectedItem={(itemSelected) =>
              props.onClickItem(getSelectedItem(getFontTypeId(14, props.styleFont.font.fontFamily.id, itemSelected.id), {wording: "fontFamily", item:itemSelected}))}
          />
        </div>;*/
        return  <div  key ={pos} style={{ marginTop: "-3px",marginLeft: "2px", height: "25px" }}>
        <DropDownListNew
            fontSize={12}
            id={"Family" + props.id }
            currentData={props.styleFont.fonts.fontFamily.values}
            initialValue={props.styleFont.font.fontFamily.value}
            onDropDownItemClick={(itemSelected) =>
              props.onClickItem(getSelectedItem(getFontTypeId(14, props.styleFont.font.fontFamily.id, itemSelected.id) , {wording: "fontFamily", item:itemSelected}))}
            onlyLabel={false} /> </div>;
      case 15:
        return <div  key ={pos} style={{ marginTop: "-3px",marginLeft: "0px", height: "25px" }}>
          <DropDownListNew
            fontSize={12}
            id={"Size" + props.id}
            currentData={props.styleFont.fonts.fontSize.values}
            initialValue={props.styleFont.font.fontSize.value}
            onDropDownItemClick={(itemSelected) =>
              props.onClickItem(getSelectedItem(getFontTypeId(15, props.styleFont.font.fontSize.id, itemSelected.id) , {wording: "fontSize", item:itemSelected}))}
            onlyLabel={false} />
        </div>;
        /*<Autocomplete 
            placeholder={props.styleFont.font.fontSize.value }
            isWrapped= {true} 
            style={{fontSize:14, width:"30px", height:"20px"}}
            containerStyle={{fontSize:14, width:"40px"}}
            emphasised= {false}
            data = {props.styleFont.fonts.fontSize.values}
            onSelectedItem={(itemSelected) =>
              props.onClickItem(getSelectedItem(getFontTypeId(15, props.styleFont.font.fontSize.id, itemSelected.id), {wording: "fontSize", item:itemSelected}))}
          />*/
      case 16:
        return <div  key ={pos} style={{ marginTop: "-3px", marginLeft: "0px", height: "25px" }}>
          <DropDownListNew
            fontSize={12}
            id={"Color" + props.id}
            currentData={props.styleFont.fonts.color.values}
            initialValue={props.styleFont.font.color.value}
            onDropDownItemClick={(itemSelected) =>
              props.onClickItem(getSelectedItem(getFontTypeId(16, props.styleFont.font.color.id, itemSelected.id), {wording: "color", item:itemSelected}))}
            onlyLabel={false} />
 
        </div>;

         /*<Autocomplete 
            placeholder={props.styleFont.font.color.value }
            isWrapped= {true} 
            style={{fontSize:14, width:"50px", height:"20px"}}
            containerStyle={{fontSize:14, width:"50px"}}
            emphasised= {false}
            data = {props.styleFont.fonts.color.values}
            onSelectedItem={(itemSelected) =>
              props.onClickItem(getSelectedItem(getFontTypeId(16, props.styleFont.font.color.id, itemSelected.id), {wording: "color", item:itemSelected}))}
          />*/
               default:
        return <ItalicIcon />;
    }
  }

  const getArray = () => {
    var nItem = 17;
    var colWidth = 20
    var width = parseInt(props.width.slice(0, -2));
    var nPossibleByRow = Math.floor(width / colWidth);
    var nRows = Math.floor(nItem / nPossibleByRow);
    var nRemainsItem = nItem % nPossibleByRow;

    var menus = [];
    if (nRows > 0)
      [...(new Array(nRows))].map(_ => menus.push([...(new Array(nPossibleByRow))]));

    if (nRemainsItem > 0)
      menus.push([...(new Array(nRemainsItem))]);

    return menus;
  }

  const onClickLinkItem = (e) => {
    var linkData = JSON.parse(JSON.stringify(link))
    linkData.isOpen = !linkData.isOpen
    linkData.position = { left: parseInt(e.target.scrollLeft) + e.clientX - 8
      , top:parseInt(e.target.scrollTop) + e.clientY + 6}
       
    setLink(linkData)
    
    //props.onClickItem(getSelectedItem(getLinkId(13),{modal: {position: position, isLinkClicked:true}}))
  }

  const onChangeLinkValue = (e) => {
    var linkData = JSON.parse(JSON.stringify(link))
    linkData.value = e.target.value
    
    setLink(linkData)
    
    //props.onClickItem(getSelectedItem(getLinkId(13),{modal: {position: position, isLinkClicked:true}}))
  }
  const closeLinkForm = () => {
    var linkData = JSON.parse(JSON.stringify(link))
    linkData.isOpen = false
    
    setLink(linkData)
    
    //props.onClickItem(getSelectedItem(getLinkId(13),{modal: {position: position, isLinkClicked:true}}))
  }

  const onClickAddLink = () => {
    
    var selectedItem = getSelectedItem(getLinkId(13))
    selectedItem["operation"] = "ADD"
    selectedItem["value"] = link.value
    props.onClickItem(selectedItem)
    closeLinkForm()
  }

  const onClickDeleteLink = () => {
    
    var selectedItem = getSelectedItem(getLinkId(13))
    selectedItem["operation"] = "DEL"
    props.onClickItem(selectedItem)
    closeLinkForm()
  }

  const getLinkComponent = () => {
    
    //var x = actualDate.currentPosition.x;
    //var y = actualDate.currentPosition.y;
    
    return (
         ReactDOM.createPortal( //position:"fixed"
        <div style ={{ left:link.position.left, top:link.position.top
          , position:"fixed", display: "flex", border: "1px Solid gray"
          , paddingTop: "10px", paddingLeft: "10px", backgroundColor: "white"
          , height: "35px", width: "210px", zIndex:2000 }}
          onClick={(e) => {e.stopPropagation() }}>
          <div>
            <input type="text" onChange={(e) => onChangeLinkValue(e) } 
            style ={{ width: "150px", height: "20px" }} value={link.value} />
          </div>
          <div onClick={() => onClickAddLink() } style ={{ marginLeft: "5px" }}>
            <ValidationCommand />
          </div>
          <div onClick={() => onClickDeleteLink() } style ={{ marginLeft: "5px" }}>
            <CloseCommand />
          </div>
        </div>,
         document.body
      )
       
    );
  };

  return (
      <div style={{ width: "auto", display: "flex" }}>
        {getArray().map((item, id) =>
          <div key={id} style={{ display: "flex", height: "25px" }}>
            {item.map((el, index) =>
              getIcon(index) 
            )}
          </div>
        )}
      </div>
  );
}
